module.exports = __webpack_public_path__ + "static/media/logo-css3.5c44e01d.svg";